module.exports = __webpack_public_path__ + "img/jntpic.89793371.jpg";